module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('div', {
    staticClass: "navbar-top",
    staticStyle: {
      "height": "inherit",
      "background-color": "#333333"
    }
  }, [_c('ul', {
    staticClass: "tableshow",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('li', {
    staticClass: "fixed text-center",
    staticStyle: {
      "vertical-align": "top",
      "background-color": "#333333"
    }
  }, [_c('div', {
    staticClass: "userba"
  }, [_c('a', {
    attrs: {
      "href": _vm.globalConfig.domain.portal
    }
  }, [_c('img', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "src": require("./img/logo.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('li', {
    staticClass: "tablecell respond",
    staticStyle: {
      "background": "#333"
    }
  }, [_c('div', {
    staticClass: "pull-right userba",
    staticStyle: {
      "margin-right": "225px"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.globalConfig.domain.portal + '/services',
      "title": "数据保全-服务与支持"
    }
  }, [_c('img', {
    staticClass: "tf",
    attrs: {
      "src": require("./img/wenhao.png"),
      "alt": "数据保全-服务与支持"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right userba",
    staticStyle: {
      "margin-right": "50px"
    }
  }, [(_vm.parentUserInfo.userId) ? [_c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "block-userinfo userbar"
  }, [_c('a', {
    staticClass: "username nomargin",
    staticStyle: {
      "padding-left": "0",
      "padding-right": "0",
      "text-align": "left",
      "color": "#ffffff"
    },
    attrs: {
      "href": "javascript:void(0)",
      "id": "addyangxin_div_block"
    },
    on: {
      "mouseover": function($event) {
        return _vm.userDetailShow()
      },
      "mouseleave": function($event) {
        return _vm.userDetailHide()
      }
    }
  }, [_c('img', {
    staticClass: "tf",
    staticStyle: {
      "margin-right": "20px",
      "border-radius": "50%"
    },
    attrs: {
      "src": _vm.loginUser.realImgPath || '/static/img/defaultUserImg.jpg'
    }
  }), _vm._v("\n                    " + _vm._s(_vm.parentUserInfo.userName) + "\n                  ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isActive),
      expression: "this.isActive"
    }],
    staticClass: "user-info user",
    attrs: {
      "id": "addyangxin_userInformation"
    },
    on: {
      "mouseleave": function($event) {
        return _vm.userInfoHide()
      }
    }
  }, [_c('div', {
    staticClass: "sidebar-userinfo"
  }, [_c('div', {
    staticClass: "row nomargin"
  }, [_c('div', {
    staticClass: "col-xs-12 photomove"
  }, [_c('a', {
    attrs: {
      "href": _vm.globalConfig.domain.accountWeb + '/profile?hm=1',
      "alt": "",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "user-photo",
    attrs: {
      "src": _vm.loginUser.realImgPath || '/static/img/defaultUserImg.jpg',
      "alt": _vm.parentUserInfo.userName
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "realN",
    attrs: {
      "src": require("./img/realN.png")
    },
    on: {
      "click": _vm.toIdentity
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "account-setting",
    attrs: {
      "title": "设置"
    },
    on: {
      "click": function($event) {
        return _vm.settings()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 loginuser"
  }, [_c('h5', {
    staticStyle: {
      "width": "90px",
      "margin-bottom": "4px",
      "-ms-flex-wrap": "nowrap",
      "flex-wrap": "nowrap",
      "overflow": "hidden",
      "white-space": "nowrap",
      "text-overflow": "ellipsis"
    }
  }, [_vm._v(_vm._s(_vm.parentUserInfo.userName))])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "border-bottom": "1px solid #dedede"
    }
  }, [_c('div', {
    staticClass: "col-xs-7"
  }, [_c('h5', [_vm._v("积分数量："), _c('span', {
    staticClass: "color-primary",
    attrs: {
      "id": "head_user_point"
    }
  }, [_vm._v(_vm._s(_vm.parentUserInfo.point))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5"
  }, [(_vm.parentUserInfo.userType == 0) ? [_c('a', {
    staticClass: "light-gray",
    attrs: {
      "href": _vm.globalConfig.domain.accountWeb + '/asset/toPointTask',
      "target": "_blank"
    }
  }, [_vm._v("积分任务")])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row userba"
  }, [_c('div', {
    staticClass: "col-xs-6 nopadding"
  }, [_c('img', {
    staticClass: "tf",
    attrs: {
      "src": require("./img/qdht.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "pagefont-color",
    attrs: {
      "href": _vm.globalConfig.domain.junziqianWebOp,
      "alt": "",
      "target": "_blank"
    }
  }, [_vm._v("我的合同")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 nopadding"
  }, [_c('img', {
    staticClass: "tf",
    attrs: {
      "src": require("./img/zscq.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "pagefont-color",
    attrs: {
      "href": _vm.globalConfig.domain.athenaWebUms,
      "alt": "",
      "target": "_blank"
    }
  }, [_vm._v("我的原创")])])]), _vm._v(" "), _c('div', {
    staticClass: "row  userba"
  }, [_c('div', {
    staticClass: "col-xs-6 nopadding"
  }, [_c('img', {
    staticClass: "tf",
    attrs: {
      "src": require("./img/dcqz.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "pagefont-color",
    attrs: {
      "href": _vm.globalConfig.domain.forensicsWebOp,
      "alt": ""
    }
  }, [_vm._v("证据存证")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "background-color": "#f0f0f0"
    }
  }, [_c('div', {
    staticClass: "col-xs-6 text-left"
  }, [(_vm.parentUserInfo.userType == 0) ? [(!_vm.loginUser.signIn) ? _c('button', {
    staticClass: "btn btn-danger btn-signin",
    on: {
      "click": function($event) {
        return _vm.clickSignIn()
      }
    }
  }, [_vm._v("签到")]) : _c('button', {
    staticClass: "btn btn-danger btn-signin",
    attrs: {
      "disabled": "disabled"
    }
  }, [_vm._v("已签到")])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('a', {
    staticClass: "light-gray",
    attrs: {
      "href": _vm.globalConfig.domain.accountWeb + '/login/accountLogout?returnURL=' + _vm.globalConfig.domain.forensicsWebOp + '/login.html'
    },
    on: {
      "click": function($event) {
        return _vm.clearLocalInfo()
      }
    }
  }, [_vm._v("退出")])])])])])])])] : [_c('div', {
    staticClass: "pull-right userba"
  }, [_c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": _vm.globalConfig.domain.forensicsWebOp + '/register.html'
    }
  }, [_vm._v("注册")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right userba"
  }, [_c('a', {
    staticStyle: {
      "padding": "0px 15px",
      "color": "#fff"
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.gotoLogin()
      }
    }
  }, [_vm._v("\n                  登录\n                ")])])]], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-53bf23d3!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/header1/Header1.vue
// module id = 316
// module chunks = 40 41 42